import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_14: FaireProductEntity = {
  token: "starter_collection_14",
  type: "product",
  name: "Mix-And-Match Chroma Napkins",
  brandName: "Atelier Saucier",
  imageUrl: "",
  priceDollars: 48,
  msrpDollars: 96,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
